export default __webpack_public_path__ + "static/media/whiteDownloadIcon.9c83e4af.svg";